import { useMountEffect } from "@react-hookz/web";
import { useLocation, useNavigate } from "react-router";

import type { FC } from "react";

const SlackPage: FC = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  useMountEffect(() => {
    void navigate(`/manage/channels/slack${search}`, { replace: true });
  });

  return <></>;
};

export default SlackPage;
